import React, { useRef} from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function HomeAdventure() {
const sliderRef = useRef(null);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 1300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    cssEase: "ease",
  };

  return (
    <>
    <div className="home-adventure">
        <div className="container">
            <div className="row">  

                <div className="col-lg-6 col-md-5 order-2 order-lg-1 order-md-1">
                    <img src="/image/advent-1.webp" className="img-responsive advent-image-1" alt="Adventure" loading="lazy"/>
                    <img src="/image/advent-2.webp" className="img-responsive advent-image-2" alt="Adventure" loading="lazy"/>
                </div>

                <div className="col-lg-6 col-md-7 order-1 order-lg-2 order-md-2">
                    <div className="challenge-detail">
                        <h4 className="heading">A Life Changing <span className="highlight">Adventure</span></h4>
                        <p>At LPS, every student’s journey is enriched through adventure, challenges, and discovery. From outdoor camps to cultural events and service projects, these experiences foster teamwork, confidence, and resilience. Each moment beyond the classroom shapes character, encourages courage, and builds lifelong memories that prepare students for real-world success with spirit and strength.</p>
                        {/* <Link className="arrow-butn">Learn More <Icons name="Longarrow_right"/></Link> */}
                    </div>

                    <div className="advent-slider">
                        <Slider {...settings} ref={sliderRef}>
                            <div>
                                <div className="advent-slideitem">
                                    <img src="/image/advent-icon-1.webp" alt="icon"/>
                                    <div>
                                        <span>Green Campus Drive for a Sustainable Tomorrow</span>
                                        <p>LPS organises an annual tree plantation and eco-gardening initiative where students, parents, and teachers join hands to create greener school surroundings. This effort builds environmental responsibility while enhancing biodiversity across campus.</p>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="advent-slideitem">
                                    <img src="/image/advent-icon-2.webp" alt="icon"/>
                                    <div>
                                        <span>Transforming Waste to Worth Through Student Action</span>
                                        <p>Through recycling workshops and plastic-free campaigns, students learn to manage waste responsibly. The initiative promotes reusing resources, reducing plastic dependency, and inspiring sustainable practices that extend beyond the school into every home.</p>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
